import { useEffect, useRef } from "react";

// Toggles .is-visible class based on whether each .reveal child is in viewport.
// Adds when scrolling down into view, removes when leaving viewport (reverse).
export function useRevealOnScroll(deps = []) {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const items = root.querySelectorAll(".reveal");
    if (items.length === 0) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          } else {
            entry.target.classList.remove("is-visible");
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    items.forEach((el, i) => {
      const delay = el.dataset.delay || `${i * 80}ms`;
      el.style.transitionDelay = delay;
      io.observe(el);
    });

    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return rootRef;
}
